import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { AuthService } from '../../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { VehicleSupplierComponent } from '../vehicle-supplier/vehicle-supplier.component'
import { VehicleTgComponent } from '../vehicle-tg/vehicle-tg.component'
import { SubClientCreateComponent } from '../../../../features/customer/sub-client/sub-client-create/sub-client-create.component'
import { VehicleCreateComponent } from '../../../../features/vehicle/vehicle-register/vehicle-create/vehicle-create.component'
import { MatCardModule } from "@angular/material/card";

@Component({
  selector: 'client',
  imports: [
    MatTabsModule,
    MatButtonModule,
    VehicleSupplierComponent,
    VehicleTgComponent,
    VehicleCreateComponent,
    MatCardModule
  ],
  templateUrl: './vehicle-register.component.html',
  styleUrl: './vehicle-register.component.scss',
  standalone: true,
  providers: [AuthService],
})
export class VehicleRegisterComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
  ) { }




  uploadList: any = false



  screenLegalClient: string = 'clientes pessoa juridica'
  screenConsultant: string = 'consultores-clientes'
  screenSubClient: string = 'sub clientes'
  // screen: string = 'cliente'
  // screen: string = 'cliente'

  ngOnInit() { }

  checkPermission(permission: string, type: 'legal' | 'sub' | 'consultant') {
    let response = false
    if (type == 'legal') {
      response = this.authService.checkPermission(
        permission,
        this.screenLegalClient,
      )
    } else if (type == 'sub') {
      response = this.authService.checkPermission(
        permission,
        // this.screenSubClient,
        'consultores-clientes',
      )
    } else if (type == 'consultant') {
      response = this.authService.checkPermission(
        permission,
        this.screenConsultant,
      )
    }
    return response
  }




  addFrot() {
    const dialogRef = this.dialog.open((VehicleCreateComponent), {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList = true
      }
    })
  }

  // newClient() {
  //   const dialogRef = this.dialog.open(ClientCreateComponent, {
  //     enterAnimationDuration: '100ms',
  //     exitAnimationDuration: '100ms',
  //     maxWidth: '100vw',
  //     width: '100vw',
  //     maxHeight: '100vh',
  //     height: '100vh',
  //     panelClass: 'dialog-fullscreen',
  //   })
  //   dialogRef.componentInstance.responseCreate.subscribe((response) => {
  //     this.legalEntityClient?.uploadList()
  //   })
  // }

  //   newSubClient() {
  //     const dialogRef = this.dialog.open(SubClientCreateComponent, {
  //       enterAnimationDuration: '100ms',
  //       exitAnimationDuration: '100ms',
  //       maxWidth: '100vw',
  //       width: '100vw',
  //       maxHeight: '100vh',
  //       height: '100vh',
  //       panelClass: 'dialog-fullscreen',
  //       data: {},
  //     })
  //     dialogRef.componentInstance.responseCreate.subscribe((response) => {
  //       this.legalEntityClient?.uploadList()
  //     })
  //   }
}
